// extracted by mini-css-extract-plugin
export default {"Label":"default-group-header-label-module__Label--mtIW1","AggregateLabels":"default-group-header-label-module__AggregateLabels--SNvzB"};